<div *ngIf="loading" class="loading-holder" >
  <mat-spinner diameter="64"></mat-spinner>
</div>
